import AuditLogs from '../features/audit-logs';

export const AuditLogsPage = () => <AuditLogs />;
